import {
  type ComponentWithAs,
  forwardRef,
  HStack,
  IconButton,
  type IconButtonProps,
  Menu,
  MenuButton,
  MenuList,
} from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { MenuItemLink } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import type { MediaModel } from "@src/utils/components/dropzone";
import { observer } from "mobx-react-lite";
import React from "react";
import type { MarkOptional } from "ts-essentials";

type TData = {
  download?: string | null;
  previews?: MediaModel[];
};

const FilePreviewButton: ComponentWithAs<
  "button",
  MarkOptional<IconButtonProps, "aria-label">
> = forwardRef((props, ref) => (
  <IconButton
    ref={ref}
    aria-label={t`view file`}
    colorScheme="grey"
    {...props}
    icon={<Icon name="file-search-02" w="5" h="5" />}
    variant="ghost"
  />
));

export const CellDocuments = observer<{ data: TData }>(function CellDocuments({
  data,
}) {
  if (!data.download && !data.previews?.length) return null;

  return (
    <HStack>
      {!!data.previews?.length && (
        <React.Fragment>
          {data.previews?.length === 1 ? (
            <FilePreviewButton
              onClick={() =>
                window.open(data.previews?.[0].urls?.preview || "", "_blank")
              }
            />
          ) : (
            <Menu>
              <MenuButton as={FilePreviewButton} />
              <MenuList>
                {data.previews?.map(({ id, urls, fileName }) => (
                  <MenuItemLink isExternal href={urls?.preview || ""} key={id}>
                    {fileName}
                  </MenuItemLink>
                ))}
              </MenuList>
            </Menu>
          )}
        </React.Fragment>
      )}

      {!!data.download && (
        <IconButton
          aria-label={t`download file`}
          colorScheme="grey"
          icon={<Icon name="file-download-02" w="5" h="5" />}
          onClick={() => {
            if (data.download) {
              window.open(data.download, "_blank");
            }
          }}
          variant="ghost"
        />
      )}
    </HStack>
  );
});
